import React from 'react';

import { Typography } from '@mui/material';

import { IFullScreenModalProps } from './types';
import { Modal } from '../Modal';

import styles from './FullScreenModal.module.scss';

export const FullScreenModal: React.FC<IFullScreenModalProps> = ({ title, body, className, close }) => {
  return (
    <Modal maxWidth={false} className={className} close={close}>
      {title && (
        <Typography variant="h5" className={styles.modalTitle}>
          {title}
        </Typography>
      )}
      {body}
    </Modal>
  );
};
